import styled from 'styled-components'

export const DivMargin = styled.div`
  padding-top: 67px;
  @media screen and (min-width: 62rem) {
    padding-top: 40px;
  }
`
